<template>
	<div class="leadobject" v-if="objData[0]">	
		<!-- <div v-if="bIsLoading && objData.length==0">loading...</div> -->
		<card class="">
			<div v-if="bIsEdit && objData.length>0">
				<!-- <div class="bntGroup">
					<base-button @click="GoToEdit(false)" type="primary" class="no-border" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
				</div> -->
				<LeadEdit :objLead="objData[0]" />
			</div>
			<div v-else class="mobilePadding">  
				<div class="row">
									
					<div class="col-lg-6 col-12 ">
				
						<div class="objHeader">
							
							<h3 class="mr-3 mb-0">ЛИД ID {{objData[0].id}}</h3>
							
							<div class="row mx-0 align-items-center">
								<div class="bntGroup mr-2">
									<base-button type="primary" class="groupfloor" simple @click="backByHistory()" ><i class="tim-icons icon-double-left"></i>Назад</base-button>
								</div>
								<!-- <div class="bntGroup" >		
									<el-tooltip content="История изменений" placement="top">			
										<button type="button" class="btn my-0 btn-icon btn-fab btn-primary btn-simple mr-2" @click="GoToHistory(objData.id)"><i class="d-inline-block tim-ic ic-history"></i></button>
									</el-tooltip>	
								</div>		 -->
								<div class="bntGroup" >						
									<button type="button" class="btn my-0 btn-icon btn-fab btn-primary btn-simple" @click="GoToEdit()"><i class="d-inline-block tim-icons icon-pencil"></i></button>
								</div>		
							</div>
						</div>

						<div class="objInfo mb-3">
							<div>
								<span class="badge badge-pill badge-primary mr-2" v-if="objData[0].operation_type !=''">{{ objData[0].operation_type }} </span>
								<span class="badge badge-pill badge-info" v-if="objData[0].isNewBuilding == 1">Квартиры в новостройках</span>
								<span class="badge badge-pill badge-info" v-if="objData[0].isNewBuilding == 0">Вторичная недвижимость</span>
								<span class="badge badge-pill badge-info" v-if="objData[0].operation_type == 'Сдать' || objData[0].operation_type == 'Снять'">Жилая аренда</span>
							</div>

							<div class="d-flex justify-content-between">
								<p class="">В работе с {{$GVO.convertDateTimeFromMysql(objData[0].InsertTime)}}</p>
								<p class="">Обновлено {{$GVO.convertDateTimeFromMysql(objData[0].UpdateTime)}}</p>  
								
							</div>


							
							
							<div class="objPass ">
								<div class="objPass-item">
									<p class="objPass-item-title">Тип недвижимости</p>
									<p>{{ objData[0].lead_obj_type }}</p>
								</div>
								<div class="objPass-item">
									<p class="objPass-item-title">Источник</p>
									<p>{{ objData[0].import_id }} <span v-if="objData[0].dialed_number && objData[0].dialed_number!=''"> c номера {{ this.$GVO.formatPhoneNumber(objData[0].dialed_number)}}
								</span></p>
								</div>
								<div class="objPass-item">
									<p class="objPass-item-title">Рекламный источник</p>
									<p>{{ objData[0].adsSourceName }}</p> 
								</div>
								<div class="objPass-item" v-if="objData[0].description && objData[0].description!=''">
									<p class="objPass-item-title">Примечание</p>
									<!-- <p class="objPass-item-text">{{ objData[0].description }}</p>  -->
									<p class="objPass-item-text" v-html="$GVO.parseLink(objData[0].description)"></p> 
									
								</div>
							</div>
						</div>

						<div class="objInfo mb-3">
							<h6>состояние</h6>
							<div class="objPass-item">
								<!-- <p class="objPass-item-title">Статус</p> -->
								<!-- <p>{{ objData[0].lead_status }}</p>  -->
								<span v-if="objData[0].lead_status!=''" class="badge " :class="[{'badge-danger': objData[0].lead_status == 'Не отработан'}, {'badge-success': objData[0].lead_status == 'Назначен ответственный'}, 
																								{'badgeDeficient': objData[0].lead_status == 'Некачественный лид'}, {'badge-warning': objData[0].lead_status == 'Повторный звонок'}]" >{{objData[0].lead_status}}</span>
							</div>

						</div>

						
						<div class="objInfo mb-3" >
							<h6>клиент</h6>
							<div class="objPass-item">
								<p v-if="objData[0].isAgent == 1" class="objPass-item-title">Агент-посредник</p>
								<p v-if="objData[0].isAgent == 0" class="objPass-item-title">Собственник</p>
								<router-link :to="'/data/clients/id/'+objData[0].client_id"  v-if="objData[0].client_name != ''"> {{ objData[0].client_name }}</router-link>
							</div>
							
							<div class="objPass-item" >
								<p class="objPass-item-title">Контакты</p>
								<p v-if="contacts"><ReClientContacts :contacts="contacts"/></p>
								<p v-else-if="objData[0].phone && objData[0].phone!=''">{{ this.$GVO.formatPhoneNumber(objData[0].phone) }}</p>
							</div>

							<div class="objPass-item" v-if="this.objData[0].service_json!= ''" >
								<p class="objPass-item-title">Услуги клиента</p>
								<p v-if="clientServices.services.length > 0"> <span v-for="(service,index) in clientServices.services" :key="index">ИД {{ service }}, </span> </p>	
								<!-- <p v-if="clientServices.services_task.length > 0"> <span v-for="(task,index) in clientServices.services_task" :key="index">ИД {{ task }}, </span> </p>	 -->
							</div>
							<!-- <p>service_json {{ this.objData[0].service_json }}</p> -->
							

						</div>

						<div class="objInfo mb-3">
							<h6>объекты</h6>
							<div class="objPass-item">
								<!-- <p class="objPass-item-title">Данные по объекту</p> -->
								<div v-if="masLeadObjects && masLeadObjects.length>0" class="ml-1">
									<ul class="list-unstyled result-marker">
										<li v-for="obj in masLeadObjects" style="border-bottom: 1px dashed #01B0E0; margin-bottom: 15px;" :key="obj.id">
											<!-- <span><b>id</b>: {{ obj.id }}, </span> -->
											<router-link :to="'/data/module/mo/object/'+obj.id" class="mr-2">Объект ID: {{obj.id}}</router-link>,
											<span> цена: <b>{{ $GVO.number_format(obj.price,0,'.',' ') }} ₽</b>, </span>
											<!-- <span><b>площадь:</b> {{ obj.square }} м2, </span> -->
											<!-- <span v-if="obj.roomsCountTotal && obj.roomsCountTotal!=''"><b >количество комнат:</b> {{ obj.roomsCountTotal }}, </span> -->
											<!-- <span v-if="obj.landSquare && obj.landSquare!=''"><b >площадь участка:</b> {{ obj.landSquare }} м2, </span> -->
											<!-- <span><b>ответственный за услугу:</b> {{ obj.service_agent_fio }}, </span> -->
											<!-- <span><b>тип сделки:</b> {{ obj.dealType }}, </span> -->
											<span>тип объекта: <b>{{ obj.objectType }}</b>, </span>
											<span v-if="obj.MapAddress && obj.MapAddress.address && obj.MapAddress.address.text != ''">адрес: <b>{{ obj.MapAddress.address.text }}</b></span>
											<span v-else-if="obj.search_text_field != ''">адрес: <b>{{ obj.search_text_field }}</b></span>
											<div v-if="obj.service_agent_id != ''" class="d-flex align-items-center">
												<p><b class="mr-1">Ответственный за услугу: </b> <router-link :to="`/data/staff/id/${obj.service_agent_id}`"> {{obj.service_agent_fio}}</router-link></p>
												<el-popover
													placement="right"
													:title="obj.service_agent_fio"
													width="500"
													trigger="click"
													
													>
													<template v-slot:reference>
														<!-- <span class="font-weight-bold mr-1" >Ответственный за услугу: </span>  -->
														<!-- <i class="tim-ic ic-eye"></i> -->
														<base-button class="btn btn-icon no-border btn-simple btn-primary my-0 ml-2 btn-watch-icon" ><i class="tim-ic ic-eye"></i></base-button>
														<!-- <a :href="`/data/staff/id/${obj.service_agent_id}`"> {{obj.service_agent_fio}}</a> -->
													</template>
													<template v-slot:default>
														<div class="" >
															
															<!-- <ReLeadStaffInfo :agent_id="obj.service_agent_id" :agent_name="obj.service_agent_fio" :lead_id="objData[0].id" /> -->
															<ReLeadStaffInfo :objData="obj" :lead_id="objData[0].id" />
														</div>
													</template>
													
												</el-popover>
											</div>
										</li> 
									</ul> 
								</div>
								
							</div>
						</div>

						<div class="objInfo mb-3" v-if="masLeadObjects && masLeadObjects.length==0">
							<h6>ответственный</h6>
							<div class="objPass-item">
								<p>{{ objData[0].agent_name }}</p> 
							</div>
							<!-- <span class="text-danger">Сюда записывается чел из формы, там где в компоненте и звониишь, и выбираешь сотрудника. Рук ниже тоже от этого чела. Для всех ситуаций, кроме объектов</span> -->

							<div class="objPass-item align-items-center" v-if="masStaff[0]">
								<p class="objPass-item-title mb-0">Контакты</p>
								<p class="mb-0" v-if="masStaff[0].MobilePhone == '' && masStaff[0].InternalPhone ==''">Нет данных</p>
								<div class="d-flex align-items-center mr-3" v-if="masStaff[0].MobilePhone && masStaff[0].MobilePhone !=''">
								 	<p class="mb-0">моб. {{ masStaff[0].MobilePhone  }} </p>	
									<RePhoneCallButton :phone="masStaff[0].MobilePhone" :lead_id="objData[0].id" borderStyle="noborder" />
								</div>
								<div class="d-flex align-items-center" v-if="masStaff[0].InternalPhone && masStaff[0].InternalPhone !=''">
									<p class="mb-0">доб. {{ masStaff[0].InternalPhone }}</p> 
									<RePhoneCallButton :phone="masStaff[0].InternalPhone" :lead_id="objData[0].id" borderStyle="noborder"/>
								</div>
								
								
							</div>
							<div class="bossblock" v-if="masStaff[0]">
								<p class="objPass-item-title " >Руководитель</p>
								<div class="objPass-item" v-if="masStaff[0]">
									<p v-if="masStaff[0] && masStaff[0].BossName && masStaff[0].BossName !='' && typeof masStaff[0].BossName !='undefined'">{{ masStaff[0].BossName }}</p>
								</div>
							</div>
							<div class="objPass-item align-items-center" v-if="masStaff[0]">
								<p class="objPass-item-title mb-0">Контакты</p>
								<template v-if="masStaff[0] && masStaff[0].BossCode && masStaff[0].BossCode !='' && typeof masStaff[0].BossCode !='undefined'">
									<div class="d-flex align-items-center mr-3" v-if="this.masContactsBoss.MobilePhone && this.masContactsBoss.MobilePhone !=''">
										<p class="mb-0">моб. {{ this.masContactsBoss.MobilePhone  }} </p>	
										<RePhoneCallButton :phone="this.masContactsBoss.MobilePhone" :lead_id="objData[0].id" borderStyle="noborder" />
									</div>
									<div class="d-flex align-items-center" v-if="this.masContactsBoss.InternalPhone && this.masContactsBoss.InternalPhone !=''">
										<p class="mb-0">доб. {{ this.masContactsBoss.InternalPhone }}</p> 
										<RePhoneCallButton :phone="this.masContactsBoss.InternalPhone" :lead_id="objData[0].id" borderStyle="noborder"/>
									</div>
								</template>
							</div>
							
							<div v-if="masStaff[0] && masStaff[0].Branch && typeof masStaff[0].Branch != 'undefined' && masStaff[0].Branch.allBranchArrRecur.length > 0">
								<div class="pr-3">
									<ReBranchPrint :masBranch="masStaff[0].Branch.allBranchArrRecur"/>
								</div>
							</div>

						</div>
						

						<div class="objInfo mb-3">
							<h6>создатель</h6>
							<div class="objPass-item" >
								<p v-if="objData[0].author_name">{{ objData[0].author_name }}</p> 
								<p v-if="objData[0].auto == 1">Лид создан автоматически</p>
							</div>

						</div>

						<!-- <pre>{{objData}}</pre>    -->

					</div>
					<div class="col-lg-6 col-12 ">
						<div class="col-title">
							<h3>ЛЕНТА</h3>
						</div>
						<ReLeadLentaNest :lead_id="objData[0].id" :client_phone="objData[0].phone" />
											
					</div> 
				</div>
			</div>
		</card>
	</div>
</template>

<script>
// import { Collapse, CollapseItem } from 'src/components';
import { Carousel, CarouselItem,  Select, Option, Popover } from "element-ui";	
// import {eventEmitter} from "src/plugins/globalComponents.js";
import LeadEdit from  'src/our_pages/LeadEdit.vue';
import ReLeadLentaNest from "src/our_components/ReLeadLentaNest.vue";
import ReBranchPrint from 'src/our_components/ReBranchPrint.vue';
import RePhoneCallButton from "src/our_components/RePhoneCallButton.vue";
import ReLeadStaffInfo from 'src/our_components/ReLeadStaffInfo.vue';
import ReClientContacts from 'src/our_components/ReClientContacts.vue';

export default {
	name: 'leadobject-page',
	components: {
		// Collapse,
		// CollapseItem,
		[Carousel.name]: Carousel,
		[CarouselItem.name]: CarouselItem,
		[Option.name]: Option,
		[Select.name]: Select,
		[Popover.name]: Popover,
		LeadEdit,
		ReLeadLentaNest,
		ReBranchPrint,
		RePhoneCallButton,
		ReLeadStaffInfo,
		ReClientContacts
	},
	props: {
		findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
			type: String,
			default: '',
		},
		
	},
	data () {
		return {
			ver: 1,
			objData: [],
			masStaff: [],
			bIsLoading: true,
			bIsEdit: false,
			masContactsAgent: [],
			masContactsBoss: [],
			masLeadObjects: [],
			
			// anchorServiceID: '',
			// objGetParams: {},
		}
	},
	watch: {
		$route(to, from) {
			if(location.pathname.indexOf('/edit') != -1){
				this.bIsEdit = true;
			}else{
				this.bIsEdit = false;
			}
		}
		
	},
	computed: {
		clientServices: function(){
			let masServices = [];
			let arrServices = {};
			if(this.objData[0].service_json!= '') {
				// console.log(objData[0].service_json);
				arrServices = JSON.parse(this.objData[0].service_json);
				// console.log(typeof arrServices);
				// for (let i = 0; i < arrServices.length; i++){
				// 	masServices.push(arrServices[i]);	
				// 	// for (let value of Object.values(arrServices[i])) {
				// 	// 	masServices.push({filename: value.replace(/\\/g,'')});						
						
				// 	// }
				// }
				
			}
			// console.log(masServices);
			return arrServices;
		},
		contacts(){
			try{
				return JSON.parse(this.objData[0].client_contacts)||[];
			}catch(e){
				return [];
			}
		}
	},
	methods: {		
		
		getObject(){
			// console.log('getObject',this.$route.params.obj_id);
			let lead_id = typeof this.$route.params.lead_id == 'undefined'?'-1':this.$route.params.lead_id;
			// this.objGetParams = this.$GVO.GetAllGet();
			if(typeof this.$route.params.lead_id != 'undefined'){
				this.$GVO.ApiCall('LEAD.GET',{flt:{id:lead_id}})
				.then((objApi) => {
					this.bIsLoading = false;

					if(objApi.success === true){ 
						this.objData = this.$GVO.unlinkObject(objApi.data);
						// console.log(this.objData);
						if(this.objData[0].objects_json !='' && typeof this.objData[0].objects_json !='undefined'){
							this.masLeadObjects = JSON.parse(this.objData[0].objects_json);
						}
						if(this.objData[0].agent_id !='' && typeof this.objData[0].agent_id !='undefined'){
							this.getStaff(this.objData[0].agent_id);
						}
						
					}else{
						this.objData = [];
					} 
				}).catch(errorObjApi => {this.objData = []; console.error(errorObjApi); });
					
			}
		},
		GoToEdit(bGoEdit=true){
			//this.bIsEdit = bGo;
			if(bGoEdit){
				this.$router.push({path: '/data/callcenter/id/'+this.$route.params.lead_id+'/edit'});
				// this.$router.push({path: '/data/callcenter/id/'+this.$route.params.lead_id+'/edit?client_type='+this.masClient[0].client_type});
			}else{
				if(location.pathname.indexOf('/data/callcenter/add') != -1){
					this.$router.push({path: '/data/callcenter'});
				}else{
					this.$router.push({path: '/data/callcenter/id/'+this.$route.params.lead_id});
				}
			}
		},
		getStaff(agent_id){
			this.$GVO.ApiCall('GET',{obj:'staff' ,flt:{code:agent_id}})
			.then((objApiStaff) => { 
				// console.log(objApiStaff);
				if(objApiStaff.success === true){
					this.masStaff = this.$GVO.unlinkObject(objApiStaff.data);

					if(this.masStaff[0].BossCode && this.masStaff[0].BossCode !='' && typeof this.masStaff[0].BossCode !='undefined') {
						this.$GVO.ApiCall('GET_MAIN_CONTACTS',{obj:'staff' ,flt:{code:this.masStaff[0].BossCode}})
						.then((objApi) => { 
							if(objApi.success === true){
								this.masContactsBoss = this.$GVO.unlinkObject(objApi.data[0]);
							}else {this.masContactsBoss = [];}
						}).catch(errorObjApi => {console.error(errorObjApi); });
					}
					
				}else{
					this.masStaff = [];
				} 
				
				
			}).catch(errorObjApi => {this.masStaff = []; console.error(errorObjApi); });
		},
		backByHistory(){
			this.$router.back();
			// this.$router.go(-1);
		},
		
		// receiveEmitAnchor(service_id){
		// 	this.anchorServiceID = service_id;
		// 	//console.log('You clicked this.anchorServiceID: ' + this.anchorServiceID);
		// }
		

	},
	mounted(){
		this.getObject();
		
	},
	created(){
		if(location.pathname.indexOf('/edit') != -1){
			this.bIsEdit = true;
		}else{
			this.bIsEdit = false;
			
		}

	}
}
</script>
<style scoped>

.leadobject {width: 100%;}
.objHeader {display: flex; padding: 0px 0px 15px 0px; justify-content: space-between; flex-wrap: wrap; align-items: flex-end;}


.flatPhotos {height: auto; flex-shrink: 0;}
.objPass {border-top: 1px solid #01b0e0; margin-top: 10px; padding-top: 10px;  display: flex; flex-direction: column;} 
.bossblock {border-top: 1px solid #01b0e0;  margin-top: 10px; padding-top: 10px; display: flex;}
.objPass-item {display: inline-flex;}
.objPass-item-text {word-break: break-word;}
.objPass-item-title {font-weight: bold; margin-right: 10px; }
.structure-btns > button {width: 100%;}
.icon-folder {width: 18px; height: 18px; background-image: url('/img/icons/folder.svg'); background-repeat: no-repeat;  margin: 0px 7px 3px 0px;}
.leadobject >>> .form-options-group {width: 100%;}
.leadobject >>> .bntGroup {display: flex; justify-content: space-around;}
.leadobject >>> .map{height: auto;}

.objInfo {border: 1px dashed #01b0e0; border-radius: 6px; display: flex;  flex-direction: column; padding: 10px;}
.objInfo h6 {color: #01b0e0;}

.leadobject >>> .tree-list {padding-left: 0;}


/*===carousel===============================*/

.leadobject >>> button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  outline: none!important;
}
.leadobject >>>  button:focus {outline: none!important;}
.leadobject >>> .el-carousel__arrow {background-color: rgb(62, 80, 101, 0.32);}
.leadobject >>> .el-carousel__arrow--right {right: 0;}
.leadobject >>> .el-carousel__arrow--left {left: 0;}
.flatPhotos img {height: 100%; border: 1px solid transparent; margin: 0 auto; display: block; object-fit: contain;}
.objectProgress .el-carousel__item:nth-child(2n) {
  background: url("/img/73b0903ac774c473d1cd176b2fbe999f.jpeg") no-repeat center;
  background-size: contain;
} /*план поэтажный*/ 
.objectProgress .el-carousel__item:nth-child(2n + 1) {
  background: url("/img/9bht27nx4iuqcw3n0s4wyns4.png") no-repeat center;
  background-size: contain;
} /*план кв*/ 



/*===collapse===============================*/

.objPass >>> .card-collapse .card:not(.card-cinc) .card-header {padding-top: 0px;}
.objPass >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01b0e0;}
.objPass >>> .card-collapse .card:not(.card-cinc) .card-body {padding-right: 0px; padding-left: 0px;}
.objPass-container {display: flex; flex-direction: column;}
.objPass-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.objPass-btn {display: flex; justify-content: space-between; margin-top: 10px;}
.objPass-btn > button {width: 100%;}

.objPass-row h3{margin-bottom: 0px;}


.objectInfo, .priceFlow  {display: flex; justify-content: space-between; flex-wrap: wrap;}
.objectInfo h4:first-child {margin-right: 15px;}
.objectAddress {display: flex; flex-wrap: wrap;}
.metro {display: flex; align-items: center; flex-wrap: wrap;}
.metroIc {margin-right: 7px;}
.metroIc {margin-bottom: 8px;}
.service-title {display: flex; flex-wrap: wrap;}
.marker::before {
	content: "\20DD";
	color: #01B0E0;
	padding-right: 18px;
	font-size: 12px;
	font-weight: normal;
}
.object-row {display: flex; justify-content: space-between; margin-bottom: 5px;}
.object-row > p:first-child {min-width: 100px; margin-right: 10px;}
.objectPass-row {display: flex; flex-wrap: wrap; justify-content: flex-end;}
.objectPass-row p {position: relative; padding-left: 10px;}
.objectPass-row p:not(:first-child)::before {
	content: '';
	position: absolute;
	height: 4px;
	width: 4px;
	border-radius: 50%;
	background: #ccc;
	left: 3px;
	top: 9px;
} 
.collapseRegular >>> .card-collapse {border-right: unset!important;}
.collapseRegular >>> .card-collapse .card:not(.card-cinc) .card-header a {
    color: #01B0E0;
}
.collapseRegular >>> .card-header {padding-bottom:0px!important;}
.leadobject .my-row .card-collapse{
	border-right: 1px solid #01b0e0;
	height: fit-content;
	display: inline-block;/**/
	width: 50%;
	padding: 0px;
}
.card-collapse > .card > .card-header{
	border-bottom: 2px solid #01B0E0;
}
.leadobject .my-row{
	padding: 0px 20px;
}
.leadobject >>> .my-float-pin > div:nth-child(2){
	border-right: 0px;
	float: right;
}

.leadobject >>> .card-collapse .postForm {
    background: #27293d;
}
.leadobject >>> .clientExists {display: none;}
.leadobject >>> .form-options .bntGroup > * {width: fit-content;}

.leadobject >>> .addClient {border: 1px dashed #ff8d72; border-radius: 6px; padding: 10px 15px;}
.leadobject >>> .callform {border: 1px dashed #01B0E0; border-radius: 6px; padding: 10px 15px;}
.leadobject >>> .badgeDeficient {background-color: rgb(124, 6, 8); color: white;}
.leadobject >>> .col-title {margin-top: 15px;}

@media (max-width: 768px) {	
	.objPass {margin-top: 20px; padding: 0px 10px 0px 5px!important;}
	.objPass-btn {flex-wrap: wrap;}
	.objPass-btn > button:first-child {margin-right: 0px;}
	.calcs {order: 1; margin-bottom: 20px;}
	.banks {order: 2; padding-right: 0px;}
	.monthly-pay h4 {margin-bottom: 0px;}
	.calcs {padding-left: 0px;}
	.bank-header {flex-wrap: wrap;}
	.objHeader {padding: 15px 0px;}
	.cell-agent {flex-wrap: wrap;}
	.leadobject .my-row .card-collapse{
		border-right: 0px;
		display: block;
		width: 100%;			
	}
	.leadobject .my-row > div:nth-child(2){
		float: none;
	}
	.mobilePadding > .card-body {padding: 15px 0;}
	.leadobject >>> .card-collapse .card-body {padding: 5px 0;}
	.task-pl-3 {padding-left: 0px;} 
	.leadobject >>> .map {display: none;}
}


@media (max-width: 520px){
	.leadobject .my-row{
		padding: 0px 8px;
	}
}

</style>
